/**
 * 配置“生产环境”的store
 */

import {
  createStore,
  applyMiddleware,
  compose
} from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers';
import * as localState from './localState';

const enhancer = compose(applyMiddleware(thunk, localState.middleware));

export default function getStore(initialState) {
  let store = createStore(reducers, initialState, enhancer);

  return store;
}



// WEBPACK FOOTER //
// ./src/store/index.prod.js